import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController, AlertController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { LoadingProvider } from '../../providers/loading/loading';
import { Http } from '@angular/http';
import { SelectSearchableComponent } from 'ionic-select-searchable';

@Component({
  selector: 'page-change-contact-type-popup',
  templateUrl: 'change-contact-type-popup.html',
})
export class ChangeContactTypePopupPage {
  linkUnlinkContactTypeForm: FormGroup;
  public form_name: any;
  public getRole: any;
  public header_title: any;
  public allBrokers: any;
  public userRole: any;
  public contactDetails: any;
  public contact_uid: any;
  public primary_contact_uid: any;
  public secondary_contact: any;
  public contact_type: any;
  public ports: any;
  public port: any;

  public validation_messages = {
    'contactPerson': [
        { type: 'required', message: 'Please select secondary contact.' }
    ]
  }
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public formBuilder: FormBuilder, 
    public afs: AngularFirestore, 
    public modalCtrl: ModalController, 
    public afAuth:AngularFireAuth, 
    public toastCtrl: ToastController,
    public loadingProvider: LoadingProvider,
    public http: Http,
    public alertCtrl: AlertController,
    public db: AngularFirestore
  ) {
    this.linkUnlinkContactTypeForm = formBuilder.group({
      contactPerson: ['', Validators.compose([Validators.required])]
    });

    this.getAllContacts().subscribe((data)=>{
      if(data.length > 0){
        //console.log(data)
        this.ports = data
      }
    });  

    // this.ports = [
    //   { id: 0, name: 'Tokai', country: 'Japan' },
    //   { id: 1, name: 'Vladivostok', country: 'Russia' },
    //   { id: 2, name: 'Navlakhi', country: 'India' }
    // ];
  }

  portChange(event: {
    component: SelectSearchableComponent,
    value: any 
  }) {
    console.log('port:', event.value);
  }

  getAllBrokers (){
    return this.db.collection<any>( "users" , ref => ref.where('roles.broker','==',true )).valueChanges ();
  }

  getContactDetails (){
    return this.db.collection<any>( "users" , ref => ref.where('uid','==',this.contact_uid )).valueChanges ();
  }

  getAllContacts (){
    return this.db.collection<any>( "users" , ref => ref.where('roles.contact','==',true )).valueChanges ();
  }

  isFieldValid(field: string) {
    return !this.linkUnlinkContactTypeForm.get(field).valid && this.linkUnlinkContactTypeForm.get(field).touched;
  }

  getAllRealestate (contact_uid){
    return this.db.collection<any>( "SDF_realestate" , ref => ref.where('primary_uid','==',contact_uid )).valueChanges ();
  }
  
  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  public closeModal(){
    this.navCtrl.pop();
  }

  unlinkContact(contact_uid){
    let alert = this.alertCtrl.create({
      title: 'Confirm Unlink contact',
      message: 'Are you sure you want to Unlink this contact?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(contact_uid !=""){
                  this.loadingProvider.startLoading();
                  let postData = {
                    'contact_id' : contact_uid,
                    'primary_contact_uid' : this.primary_contact_uid
                  }
                  //console.log(postData);
                  this.unlinkContactRequest(postData);
                }
              }
          }
      ]
    });
    alert.present();
  }

  linkContact(){
    if(!this.linkUnlinkContactTypeForm.valid){
      this.linkUnlinkContactTypeForm.get('contactPerson').markAsDirty();
      this.linkUnlinkContactTypeForm.get('contactPerson').markAsTouched();
    }else{
      let alert = this.alertCtrl.create({
        title: 'Confirm Link contact',
        message: 'Are you sure want to Link this contact as secondary?',
        buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
            text: 'Yes',
            handler: () => {
              if(this.contact_uid !=""){
                this.loadingProvider.startLoading();
                let contactPerson = this.linkUnlinkContactTypeForm.value.contactPerson;
                console.log(contactPerson.main_contact_uid)
                console.log(contactPerson.secondary_contact_uid)
                if(contactPerson.main_contact_uid == null || contactPerson.main_contact_uid == "" || contactPerson.main_contact_uid == undefined){
                  if(contactPerson.secondary_contact_uid == null || contactPerson.secondary_contact_uid == "" || contactPerson.secondary_contact_uid == undefined){
                    let postData = {
                      "secondary_contact_uid": contactPerson.uid,
                      "contact_uid": this.contact_uid
                    }
                    this.link_secondary_contact(postData) 
                  }else{
                    this.loadingProvider.stopLoading();
                    this.presentToast('This contact already secondary contact of other primary contact')
                  }
                }else if(contactPerson.secondary_contact_uid == null || contactPerson.secondary_contact_uid == "" || contactPerson.secondary_contact_uid == undefined){
                  this.loadingProvider.stopLoading();
                  this.presentToast('This contact already primary contact of other secondary contact')
                }
              }
            }
          }
        ]
      });
      alert.present();
    }
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

  unlinkContactRequest(postData){
    console.log(postData)
    const thiss = this;
    const contactRequest = this.db.collection('/users');
    contactRequest.doc(postData.contact_id).update({
      contact_type : 'Primary Contact',
      main_contact_uid : null
    }).then(function() {
      const contactRequest1 = thiss.db.collection('/users');
      contactRequest1.doc(postData.primary_contact_uid).update({
        secondary_contact_uid : null
      }).then(function() {
        thiss.loadingProvider.stopLoading();
        thiss.presentToast('Unlink successfully')
      }).catch(function(error) {
        thiss.loadingProvider.stopLoading();
        thiss.presentToast('Unlink successfully')
        //thiss.presentToast('Unlink successfully')
      });
    }).catch(function(error) {
      thiss.loadingProvider.stopLoading();
      thiss.presentToast('Something Went wrong please try after some time.')
    });
  }

  link_secondary_contact(postData){
    console.log(postData)
    const thiss = this;
    const contactRequest = this.db.collection('/users');
    contactRequest.doc(postData.contact_uid).update({
      secondary_contact_uid : postData.secondary_contact_uid
    }).then(function() {
      const contactRequest1 = thiss.db.collection('/users');
      contactRequest1.doc(postData.secondary_contact_uid).update({
        contact_type : 'Secondary Contact',
        main_contact_uid : postData.contact_uid
      }).then(function() {
        thiss.updateRealEstate(postData.contact_uid, postData.secondary_contact_uid);
        thiss.updateRealEstate(postData.secondary_contact_uid, postData.contact_uid);
        thiss.loadingProvider.stopLoading();
        thiss.presentToast('Link successfully')
      }).catch(function(error) {
        thiss.loadingProvider.stopLoading();
        thiss.presentToast('Something Went wrong please try after some time.')
      });
    }).catch(function(error) {
      thiss.loadingProvider.stopLoading();
      thiss.presentToast('Something Went wrong please try after some time.')
    });
  }

  phoneInput(event) {
    //48 - 57
    let pass = /[4][8-9]{1}/.test(event.charCode) || /[5][0-7]{1}/.test(event.charCode);
    if (!pass) {
      return false;
    }
  }

  updateRealEstate(contact_uid, secondary_contact_uid){
    console.log('updateRealEstate')
    console.log(contact_uid)
    console.log(secondary_contact_uid)
    this.getAllRealestate(contact_uid).subscribe((data)=>{
      const thiss = this;
      if(data.length > 0){
        data.forEach(function (value, index) {
          const contactRequest = thiss.db.collection('/SDF_realestate');
          contactRequest.doc(value.document_id).update({
            secondary_uid : secondary_contact_uid
          });
        })
      }
    }); 
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChangeContactTypePopupPage');
    this.form_name = "eLINK Finance";
    this.header_title = "Change Contact Type";
    //let uid = window.localStorage.getItem("uid");
    
    this.contact_uid = this.navParams.get("contact_uid");
    this.getAllBrokers().subscribe((data)=>{
      this.allBrokers = data;
    });
    this.getContactDetails().subscribe((data)=>{
      if(data.length > 0){
        //console.log(data)
        this.contact_type = data[0].contact_type
        this.contactDetails = data[0].firstname+' '+data[0].lastname;
        this.primary_contact_uid = data[0].main_contact_uid;
        this.secondary_contact = data[0].secondary_contact_uid;
        this.linkUnlinkContactTypeForm.controls.contactPerson.setValue(data[0].reference_broker);
      }
    });    
    this.userRole = window.localStorage.getItem("userRole");  
  }

}



// WEBPACK FOOTER //
// ./src/pages/change-contact-type-popup/change-contact-type-popup.ts